import { render, staticRenderFns } from "./AddCover.vue?vue&type=template&id=04a005bd&scoped=true&"
import script from "./AddCover.vue?vue&type=script&lang=js&"
export * from "./AddCover.vue?vue&type=script&lang=js&"
import style0 from "./AddCover.vue?vue&type=style&index=0&id=04a005bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a005bd",
  null
  
)

export default component.exports